import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { QuantityType } from "../../../../graphql/generated";
import { ConditionValueSelectorComponentProps } from "../ConditionForm";
import quantityTypeLabel from "../../../../utils/labels/billingRule/quantityTypeLabel";
import { testIds } from "./QuantityTypeSelect.testIds";

const QuantityTypeSelect = ({
  label,
  value,
  onChange,
  ...props
}: ConditionValueSelectorComponentProps) => {
  return (
    <FormControl fullWidth size="small" {...props}>
      <InputLabel>{label}</InputLabel>
      <Select data-testid={testIds.quantityTypeSelectControl}
        value={value || QuantityType.Ordered}
        label={label}
        onChange={(e) => onChange(e.target.value)}
        size="small"
      >
        {Object.values(QuantityType).map((type) => (
          <MenuItem data-testid={`${testIds.quantityTypeSelectOption}-${type}`} key={type} value={type}>
            {quantityTypeLabel(type)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default QuantityTypeSelect;
